<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <div class="modal fade" id="costumModaltambah" data-easein="flipBounceYIn" tabindex="-1" role="dialog"
            aria-labelledby="costumModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false"
            style="background: rgba(240, 248, 255, 0.1);">
            <div class="modal-dialog" style="position: fixed;top: 20%;left: 40%;transform: translate(-50%, -50%);">
                <div class="modal-content" style="width: 50vw !important;">
                    <div class="modal-header">
                        <h4 class="modal-title">Pilihan Data</h4>
                        <button type="button" class="close" aria-label="Close" @click="tutupmodal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body text-justify">
                        <p>
                        <div class="row">
                            <div class="col-sm-12">
                                <label>Personil </label>
                                <v-select :options="id_user" :reduce="(label) => label.code" label="label"
                                    v-model="defaultSelectedid_user" @update:modelValue="onid_userChange"
                                    style="background-color: #ffffff;padding-bottom: 10px;"></v-select>
                            </div>
                        </div>
                        </p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-success btn-sm lebar2 text-white" @click="G_tableCSVTabel4()"><i
                                class="fas fa-file-excel"></i> Export Excel</button>
                        <button type="button" class="btn btn-danger3 btn-sm lebar2 text-white" @click="tutupmodal()"> <i
                                class="far fa-times-circle"></i>
                            Batal</button>
                    </div>
                </div>
                <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
        </div>
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/DataAbsensi">Data Absensi</a></li>
                                <li class="breadcrumb-item active">Pengaturan Data Absensi</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih">
                                <div class="card-header border-transparent">
                                    <div class="col-sm-12 text-center wow fadeInDown">
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-success" data-toggle="dropdown"
                                                aria-expanded="false">
                                                <i class="fas fa-file-excel"></i> Export Excel
                                            </button>
                                            <button type="button" class="btn btn-success dropdown-toggle"
                                                data-toggle="dropdown" aria-expanded="false">
                                                <span class="sr-only">Toggle Dropdown</span>
                                            </button>
                                            <div class="dropdown-menu" role="menu" style="">
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    @click="G_tableCSVTabel1()">
                                                    Jadwal Info
                                                </a>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    @click="G_tableCSVTabel2()">
                                                    Statistik
                                                </a>
                                                <a class="dropdown-item" href="javascript:void(0)"
                                                    @click="G_tableCSVTabel3()">
                                                    Rekapitulasi Detail Abensi
                                                </a>
                                                <a class="dropdown-item" href="javascript:void(0)" @click="bukamodal()">
                                                    Data Detail Abensi Personil
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 text-center">&nbsp;</div>
                                    <div class="col-sm-11 float-left pb-2">
                                        <input type="text" v-model="carikata" class="form-control form-control-sm"
                                            placeholder="Masukkan Kata Kunci Pencarian">
                                    </div>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-0">
                                    <div class="table-responsive table-wrapper">
                                        <table class="table m-0" id="tabeldata" style="font-size: smaller;">
                                            <thead>
                                                <tr>
                                                    <th style="width: 50px;" rowspan="2">No</th>
                                                    <th style="width: 150px;" rowspan="2">Nama Personil</th>
                                                    <th style="width: 100px;" rowspan="2">Jabatan Personil</th>
                                                    <th style="width: 100px;" colspan="2">Target</th>
                                                    <th style="width: 100px;" colspan="2">Aktual</th>
                                                    <th style="width: 100px;" colspan="2">Selisih</th>
                                                    <th style="width: 50px;" rowspan="2">%</th>
                                                    <th style="width: 200px;" colspan="4">Keperluan Lain (Hari)</th>
                                                    <th style="width: 100px;" rowspan="2">Opsi</th>
                                                </tr>
                                                <tr>
                                                    <th style="width: 50px;">Hari</th>
                                                    <th style="width: 50px;">Jam</th>
                                                    <th style="width: 50px;">Hari</th>
                                                    <th style="width: 50px;">Jam</th>
                                                    <th style="width: 50px;">Hari</th>
                                                    <th style="width: 50px;">Jam</th>
                                                    <th style="width: 50px;">Sakit</th>
                                                    <th style="width: 50px;">Izin</th>
                                                    <th style="width: 50px;">Cuti</th>
                                                    <th style="width: 50px;">DL</th>
                                                </tr>
                                            </thead>
                                            <template v-for="(datalist, urutlist) in filteredKataData" :key="urutlist">
                                                <tbody>
                                                    <tr>
                                                        <td class="text-center" :class="datalist.class">{{ urutlist + 1
                                                        }}</td>
                                                        <td :class="datalist.class">
                                                            {{ datalist.nama }}
                                                        </td>
                                                        <td :class="datalist.class">
                                                            {{ datalist.jabatan }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            <span v-if="datalist.jam_bebas == 0">
                                                                {{ G_numFormat(datalist.hari_kerja_personil_biasa) }}
                                                            </span>
                                                            <span v-else>
                                                                {{ G_numFormat(datalist.hari_kerja_personil_bebas) }}
                                                            </span>
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormatKoma(datalist.jml_target_jam_kerja) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormat(datalist.hari_aktual_kerja) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormatKoma(datalist.jml_jam_kerja) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormat(datalist.selisih_hari_kerja) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormatKoma(datalist.selisih_jam_kerja) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormatKoma(datalist.persentase) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormat(datalist.hari_sakit) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormat(datalist.hari_izin) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormat(datalist.hari_cuti) }}
                                                        </td>
                                                        <td class="text-center" :class="datalist.class">
                                                            {{ G_numFormat(datalist.hari_perjalan_dinas) }}
                                                        </td>
                                                        <td class="text-center">
                                                            <button type="button"
                                                                class="btn btn-primary3 btn-sm text-white"
                                                                @click="prosesdata(datalist.id_user)"
                                                                data-toggle="tooltip" data-placement="left"
                                                                title="Edit data.."><i class="fas fa-edit"></i>
                                                                Lihat</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                            <tbody v-if="(datapesan == 'data kosong')">
                                                <tr>
                                                    <td colspan="5">Data masih kosong</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Kembali</button>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                        <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                        <div class="col-sm-12 wow fadeInDown">&nbsp;</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import xlsx from 'xlsx/dist/xlsx.full.min';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            datapesan: '',
            datamaster: [],
            carikata: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
            levelabsen: process.env.VUE_APP_LEVEL_ABSENSI,
            dataid_user: [],
            id_user: [],
            defaultSelectedid_user: {
                code: 0,
                label: 'Semua Data',
                tag: '',
            },
            selectedid_user: '',
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),

        }
    },
    computed: {
        filteredKataData() {
            const filteredWorkers = this.carikata === ""
                ? this.datamaster
                : this.datamaster.filter(wo => Object.values(wo).join("").toLowerCase().indexOf(this.carikata.toLowerCase()) !== -1);
            return filteredWorkers;
        },
        JumlahfilteredKataData() {
            var jumlah = 0;
            try {
                if (this.filteredKataData === undefined) {
                    jumlah = 0;
                } else {
                    jumlah = this.filteredKataData.length;
                }
            }
            catch {
                jumlah = 0;
            }
            return jumlah;
        },
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        bukamodal() {
            $('#costumModaltambah').modal('show');
        },
        tutupmodal() {
            $('#costumModaltambah').modal('hide');
        },
        onid_userChange(a) {
            try {
                this.selectedid_user = this.id_user[a].tag;
            }
            catch (err) {
                return;
            }
            //alert(this.selectedid_user);
        },
        async G_tableCSVTabel1() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
                responseType: 'blob',
            });
            var random = Math.random();
            var kode = this.secretencData.split("|");
            var bulan = kode[0];
            var tahun = kode[1];
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_JadwalInfo.xlsx';
            await mainAPI5.get("ExportAbsensi-DataPersonil?random=" + random + "&project_id=" + this.project_id + "&level=" + this.levelabsen + "&bulan=" + bulan + "&tahun=" + tahun).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel2() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
                responseType: 'blob',
            });
            var random = Math.random();
            var kode = this.secretencData.split("|");
            var bulan = kode[0];
            var tahun = kode[1];
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_StatistikRekap.xlsx';
            await mainAPI5.get("ExportAbsensi-Resume?random=" + random + "&project_id=" + this.project_id + "&level=" + this.levelabsen + "&bulan=" + bulan + "&tahun=" + tahun).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel3() {
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
                responseType: 'blob',
            });
            var random = Math.random();
            var kode = this.secretencData.split("|");
            var bulan = kode[0];
            var tahun = kode[1];
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_Detail_Abensi.xlsx';
            await mainAPI5.get("ExportAbsensiDetail-Detail?random=" + random + "&project_id=" + this.project_id + "&level=" + this.levelabsen + "&bulan=" + bulan + "&tahun=" + tahun).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        async G_tableCSVTabel4() {
            this.tutupmodal();
            this.halamanloading = true;
            const mainAPI5 = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
                responseType: 'blob',
            });
            var random = Math.random();
            var kode = this.secretencData.split("|");
            var bulan = kode[0];
            var tahun = kode[1];
            const filename = this.G_formatDate(Date(), 'd-M-Y') + '_Detail_Abensi_Personil.xlsx';
            await mainAPI5.get("ExportAbsensiDetail-Personil?random=" + random + "&project_id=" + this.project_id + "&level=" + this.levelabsen + "&bulan=" + bulan + "&tahun=" + tahun + "&id_user=" + this.selectedid_user).then(
                response => {
                    // Buat link download dari blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename); // nama file
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    this.halamanloading = false;
                }
            ).catch(error => {
                swal.fire('Peringatan', 'Export gagal: ' + error, 'error');
                // this.ClearlocalStorage();
                console.log(error);
                this.halamanloading = false;
            });
        },
        batalproses() {
            window.location.replace("/DataAbsensi");
        },
        prosesdata(id_user) {
            var kode = this.secretencData.split("|");
            var bulan = kode[0];
            var tahun = kode[1];
            bulan = (bulan < 10) ? "0" + bulan : bulan;
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(bulan.toString() + '|' + tahun.toString() + '|' + id_user.toString(), 'GPMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            //alert(bytes);
            //return;
            window.location.replace("/ProsesDetailAbsensi/" + bytes);
        },
        async ambildata() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            var kode = this.secretencData.split("|");
            var bulan = kode[0];
            var tahun = kode[1];
            await mainAPI.get("DataAbsensi-DataPersonil?random=" + random + "&project_id=" + this.project_id + "&level=" + this.levelabsen + "&bulan=" + bulan + "&tahun=" + tahun).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.datatahun = [];
                        this.id_user = [];
                        this.dataid_user = Response.data.content.data;
                        this.dataid_user.forEach((item) => {
                            this.id_user.push({
                                label: item.nama,
                                code: this.dataid_user.indexOf(item) + 1,
                                tag: item.id_user,
                            });
                        });
                        this.id_user.unshift({
                            label: 'Semua Data',
                            code: 0,
                            tag: '',
                        });
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                console.log(error);
                this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.ambildata();
    }
}
</script>
<style></style>